import {useEditor} from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import {TextStyle} from '@tiptap/extension-text-style'
import FontSize from '@tiptap/extension-font-size'

const useTiptapEditor = (initialContent = '', options = {}) => {
	const {
		placeholder = 'Enter your content...',
		editable = true,
		onUpdate,
		...otherOptions
	} = options

	const editor = useEditor({
		extensions: [
			StarterKit.configure({
				heading: {
					levels: [1, 2, 3],
				},
				bulletList: {
					keepMarks: true,
					keepAttributes: false,
				},
				orderedList: {
					keepMarks: true,
					keepAttributes: false,
				},
			}),
			TextStyle,
			FontSize.configure({
				types: ['textStyle'],
			}),
		],
		content: initialContent,
		editable,
		onUpdate: ({editor}) => {
			if (onUpdate) {
				const html = editor.getHTML()
				const text = editor.getText()
				onUpdate({html, text, editor})
			}
		},
		editorProps: {
			attributes: {
				placeholder,
			},
		},
		...otherOptions,
	})

	const getContent = () => {
		if (!editor) return ''
		return editor.getHTML()
	}

	const getText = () => {
		if (!editor) return ''
		return editor.getText()
	}

	const setContent = (content) => {
		if (!editor) return
		editor.commands.setContent(content)
	}

	const clearContent = () => {
		if (!editor) return
		editor.commands.clearContent()
	}

	const focus = () => {
		if (!editor) return
		editor.commands.focus()
	}

	const blur = () => {
		if (!editor) return
		editor.commands.blur()
	}

	const isEmpty = () => {
		if (!editor) return true
		return editor.isEmpty
	}

	return {
		editor,
		getContent,
		getText,
		setContent,
		clearContent,
		focus,
		blur,
		isEmpty,
	}
}

export default useTiptapEditor
